import { Loader } from '@components/loader';
import { Merchants } from '@pages/merchants';
import { Merchant } from '@root/globalTypes';
import { useListMerchants } from '@services/acquirer/merchants/list';
import { createFileRoute, redirect, useNavigate, useParams } from '@tanstack/react-router';
import { config } from './-filtersConfig';

const MerchantList = () => {
  const navigate = useNavigate();
  const { localId } = useParams({ from: '/u/$localId/_acquirer/acquirer/merchants/' });
  const { data, isPending } = useListMerchants();

  if (isPending) return <Loader />;

  return (
    <Merchants
      filtersConfig={config}
      data={data}
      newRedirect={() => {
        navigate({
          to: '/u/$localId/acquirer/merchants/new',
          params: { localId },
        }).catch((err) => console.error(err));
      }}
      onRowSelect={(merchant: Merchant) => {
        navigate({
          to: '/u/$localId/acquirer/merchants/$merchantId/orders',
          params: { merchantId: merchant.merchantId, localId },
        }).catch((err) => console.error(err));
      }}
    />
  );
};

export const Route = createFileRoute('/u/$localId/_acquirer/acquirer/merchants/')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['merchants_read'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: MerchantList,
});
